import {
  TypeClickStreamselector,
  TypeSearchSource,
} from "../libs/clickstream/types/clickStreamTypes";
import { SEARCH_SOURCE } from "utils/constants";
import useClickStreamSourceSetter from "../libs/clickstream/hooks/useClickStreamSourceSetter";

export default function useClickStreamSource() {
  const selectorsAndSearchSourceMap = new Map<
    TypeClickStreamselector,
    TypeSearchSource
  >([
    ["postCpsSearchSource", SEARCH_SOURCE.CPS],
    ["homeCpsSearchSource", SEARCH_SOURCE.CPS],
    ["searchSuggestionsSource", SEARCH_SOURCE.SUGGESTIONS],
    ["searchAutocompleteSource", SEARCH_SOURCE.AUTOCOMPLETE],
    ["searchFacetsSource", SEARCH_SOURCE.FACETS],
    ["advanceSearch", SEARCH_SOURCE.ADVANCE_FILTER],
    ["searchAutocompleteSourceDesktop", SEARCH_SOURCE.AUTOCOMPLETE],
    ["similarAdsSearchSource", SEARCH_SOURCE.SIMILAR_ADS],
    ["searchBytermSource", SEARCH_SOURCE.BY_TERM],
    ["top_search_button", SEARCH_SOURCE.BY_TERM],
    ["right_bar_section", SEARCH_SOURCE.TERM_WITH_FILTERS],
    ["continueBrowsing", SEARCH_SOURCE.RECENT_SEARCH],
    ["mobileSavedSearches", SEARCH_SOURCE.SAVE_SEARCH],
    ["latestAdsSource", SEARCH_SOURCE.LATEST_ADS],
    ["viewMoreBtnSource", SEARCH_SOURCE.SERP_VIEW_MORE],
    ["recentSearchesSource", SEARCH_SOURCE.RECENT_SEARCH],
    ["carsSpecsSource", SEARCH_SOURCE.SERP_CAR_SPECS],
    ["mobileTabletSpecsSource", SEARCH_SOURCE.SERP_MOBILE_SPECS],
    ["autosServiceSource", SEARCH_SOURCE.SERP_AUTOS_SERVICE],
    ["realEstateSource", SEARCH_SOURCE.SERP_REAL_ESTATE],
    ["searchNowBtnSource", SEARCH_SOURCE.SERP_SEARCH_NOW],
    ["homeFacetsSource", SEARCH_SOURCE.HOME_FACETS],
    ["VirtualCategorySource", SEARCH_SOURCE.VIRTUAL_CATEGORY_LIST],
    ["shopFacetSource", SEARCH_SOURCE.SHOPS_FACETS],
    ["midFacetSource", SEARCH_SOURCE.MID_FACETS],
    ["landingPageSource", SEARCH_SOURCE.SERP_LANDING],
    ["megaMenuSource", SEARCH_SOURCE.MEGA_MENU],
    ["tiktikSource", SEARCH_SOURCE.TIK_TIK],
  ]);

  useClickStreamSourceSetter(
    selectorsAndSearchSourceMap,
    (selector: TypeClickStreamselector) => {
      let searchSource = null;
      switch (selector) {
        case "top_search_button":
          let categoriesInSearchbarPlaceholder = document
            .getElementById("CategoriesInSearchbarDesktop")
            ?.getAttribute("placeholder");
          let hasFilter =
            categoriesInSearchbarPlaceholder != "All Categories" &&
            categoriesInSearchbarPlaceholder != "جميع الأقسام";
          searchSource = hasFilter
            ? SEARCH_SOURCE.TERM_WITH_FILTERS
            : SEARCH_SOURCE.BY_TERM;
          break;
        case "right_bar_section":
          let hasTerm = !!document
            .getElementById("search")
            .getAttribute("value")
            .trim();
          searchSource = hasTerm
            ? SEARCH_SOURCE.TERM_WITH_FILTERS
            : SEARCH_SOURCE.ADVANCE_FILTER;
          break;
      }
      return searchSource;
    }
  );
}
